import {takeLatest} from 'redux-saga/effects';
import {accessUser, AuthenticationTypes} from 'store/reducers/authentication';

const authenticationSagas = [
  takeLatest(AuthenticationTypes.ACCESS_REQUEST, accessUser),
];

export default authenticationSagas;
